(() => {
  const init = () => {
    const finder = document.querySelector('.njt-quick-finder');
    if (!finder || finder.dataset.ready) return;
    finder.dataset.ready = 'true';
    const toggle = finder.querySelector('.njt-vehicle-toggle');
    const panel = finder.querySelector('.njt-vehicle-panel');
    const label = finder.querySelector('[data-njt-vehicle-label]');
    const search = finder.querySelector('njt-smart-search');
    const section = finder.closest('.section-vehicle-filter--container');
    const main = section?.parentElement;
    if (main?.id === 'MainContent' && search) {
      const marker = document.createTextNode('');
      main.insertBefore(marker, section);
      const mobile = matchMedia('(max-width:749px)');
      const arrange = () => {
        if (!section.isConnected) {
          mobile.removeEventListener('change', arrange);
          marker.remove();
          return;
        }
        const active = document.activeElement;
        const restoreFocus = finder.contains(active);
        if (mobile.matches) {
          if (main.firstElementChild !== section) main.insertBefore(section, main.firstElementChild);
          if (search.nextElementSibling !== toggle) finder.insertBefore(search, toggle);
        } else {
          if (marker.nextSibling !== section) main.insertBefore(section, marker.nextSibling);
          if (toggle.nextElementSibling !== search) toggle.after(search);
        }
        if (restoreFocus && document.activeElement !== active) active.focus({preventScroll:true});
      };
      arrange();
      mobile.addEventListener('change', arrange);
    }
    const setOpen = open => {
      toggle.setAttribute('aria-expanded', String(open));
      finder.classList.toggle('njt-picker-open', open);
      panel.inert = !open;
    };
    const update = vehicle => {
      if (!vehicle) {
        try { vehicle = JSON.parse(localStorage.getItem('gta-global-vehicle-filter') || 'null'); } catch (_) {}
      }
      label.textContent = vehicle?.vehicleTitleOverwrite || vehicle?.vehicleName || label.dataset.default;
    };
    toggle.addEventListener('click', () => setOpen(toggle.getAttribute('aria-expanded') !== 'true'));
    finder.addEventListener('keydown', event => {
      if (event.key === 'Escape' && finder.classList.contains('njt-picker-open') && panel.contains(event.target)) {
        setOpen(false);
        toggle.focus();
      }
    });
    document.addEventListener('njt:vehicle-state', event => {
      update(event.detail);
      {
        const restoreFocus = panel.contains(document.activeElement);
        setOpen(false);
        if (restoreFocus) toggle.focus();
      }
    });
    window.addEventListener('storage', () => update());
    update();
    setOpen(false);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
